/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Refresh",
  size: 20
}

const SvgRefresh = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeWidth={1.1}
      d="M17.08 11.15c.01.16.02.32.02.49 0 3.89-3.16 7.05-7.05 7.05C6.16 18.68 3 15.53 3 11.63c0-3.89 3.16-7.05 7.05-7.05.85 0 1.66.15 2.41.42"
    />
    <path fill="none" d="M9.9 2l2.89 2.89-3 3.01" />
  </Svg>
)

SvgRefresh.defaultProps = defaultProps
export default SvgRefresh
